import React from 'react';

import { FormattedMessage } from 'react-intl';

import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn,
  TableHeader,
  TableHeaderColumn
} from 'material-ui/Table';

import AddButton from './../../AddButton';
import LoadMore from '../../LoadMore';
import { FormattedDate } from 'react-intl';
import ListActionItems from '../../List/ListActionItems';
import LoggedAppBar from '../../LoggedLayout/LoggedAppBar';
import LoadingSpinner from '../../LoadingSpinner';

import IconCheckBox from '../../Icons/IconCheckBox';
import IconCheckBoxChecked from '../../Icons/IconCheckBoxChecked';
import NameFormatter from '../../NameFormatter';
import FetchDataComponent from '../../common/FetchDataComponent';

class PromotionsList extends FetchDataComponent {
  static contextTypes = {
    ...FetchDataComponent.propTypes,
    muiTheme: React.PropTypes.object
  };

  constructor() {
    super();
    this.confirmRemoveMessage = (
      <FormattedMessage
        id='promotion.remove'
        defaultMessage='Are you sure want to delete promotion?'
      />
    );
  }

  render() {
    let { add, list, items, hasMore, loading } = this.props;
    let records = list.map(id => items[id]);

    let {appBar: {color}, palette: {labelColor}, baseTheme: { palette: { primary1color }} } = this.context.muiTheme;

    let tableColumnStyle= {
      color: primary1color,
      boxSizing: 'border-box'
    };

    let tableHeaderStyle = {
      color: labelColor,
      boxSizing: 'border-box'
    };

    let fixedColumnHeaderStyle = Object.assign({}, tableHeaderStyle, {width: 140});
    let fixedColumnStyle = Object.assign({}, tableColumnStyle, {width: 140});

    return (
      <div>
        <LoggedAppBar title='Promotions' isStatic/>
        <LoadingSpinner show={loading}>
            <LoadMore active={hasMore} loadMore={() => this.loadMore()}>
              <Table selectable={false}>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false} enableSelectAll={false}
                             style={{
                               backgroundColor: color
                             }}
                >
                  <TableRow>
                    <TableHeaderColumn style={fixedColumnHeaderStyle}>Published</TableHeaderColumn>
                    <TableHeaderColumn style={tableHeaderStyle}>Author</TableHeaderColumn>
                    <TableHeaderColumn style={tableHeaderStyle}>Subject</TableHeaderColumn>
                    <TableHeaderColumn style={fixedColumnHeaderStyle}>Creation date</TableHeaderColumn>
                    <TableHeaderColumn style={fixedColumnHeaderStyle}>Expiration date</TableHeaderColumn>
                    <TableHeaderColumn style={fixedColumnHeaderStyle}>Published date</TableHeaderColumn>
                    <TableHeaderColumn style={fixedColumnHeaderStyle}>Options</TableHeaderColumn>
                  </TableRow>
                </TableHeader>

                <TableBody displayRowCheckbox={false}>
                  {records.length > 0
                    ? (
                  records.map(({id, title, published, createDate, expiredDate, publishedDate, createdBy}) => (
                    <TableRow key={id} >
                      <TableRowColumn style={Object.assign({}, fixedColumnStyle, {textAlign: 'center'})}>
                        {published ? (<IconCheckBoxChecked/>) : <IconCheckBox/> }
                      </TableRowColumn>
                      <TableRowColumn style={tableColumnStyle}>
                        <NameFormatter user={createdBy}></NameFormatter>
                      </TableRowColumn>
                      <TableRowColumn style={tableColumnStyle}>{title}</TableRowColumn>
                      <TableRowColumn style={fixedColumnStyle}>
                        <FormattedDate value={createDate}/>
                      </TableRowColumn>
                      <TableRowColumn style={fixedColumnStyle}>
                        {expiredDate ? (<FormattedDate value={expiredDate}/>) : '-'}
                      </TableRowColumn>
                      <TableRowColumn style={fixedColumnStyle}>
                        {publishedDate ? (<FormattedDate value={publishedDate}/>) : '-'}
                      </TableRowColumn>
                      <TableRowColumn style={fixedColumnStyle}>
                        <ListActionItems edit={this.props.edit}
                                         remove={this.props.delete}
                                         published={published}
                                         record={items[id]}
                                         confirmMessageLabel={this.confirmRemoveMessage}
                        />
                      </TableRowColumn>
                    </TableRow>
                  ))
                    )
                    : (
                    <TableRow>
                      <TableRowColumn columnNumber={6}>Empty list</TableRowColumn>
                    </TableRow>
                  )
                  }
                </TableBody>
              </Table>
            </LoadMore>

        </LoadingSpinner>

        <AddButton onClick={add} />
      </div>
    );
  }
}

export default PromotionsList;




// WEBPACK FOOTER //
// ./src/components/Promotions/PromotionsList/PromotionsList.jsx